// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf311286","239":"ce1795c8","455":"019b4b5d"}[chunkId] + ".chunk.js";
};